var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrowDownCircle = function SvgArrowDownCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 25",
    className: "arrow-down-circle_svg__svg-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4.496a8 8 0 1 0 0 16 8 8 0 0 0 0-16zm-10 8c0-5.523 4.477-10 10-10s10 4.477 10 10-4.477 10-10 10-10-4.477-10-10z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 8.265a.76.76 0 0 1 .75-.77.76.76 0 0 1 .75.77v6.604l.97-.994c.293-.3.767-.3 1.06 0 .293.3.293.787 0 1.088l-2.25 2.307c-.293.3-.767.3-1.06 0l-2.25-2.307a.783.783 0 0 1 0-1.088c.293-.3.767-.3 1.06 0l.97.994V8.265z",
    fill: "currentColor"
  })));
};

export { SvgArrowDownCircle as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNSIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEyIDQuNDk2YTggOCAwIDEwMCAxNiA4IDggMCAwMDAtMTZ6bS0xMCA4YzAtNS41MjMgNC40NzctMTAgMTAtMTBzMTAgNC40NzcgMTAgMTAtNC40NzcgMTAtMTAgMTAtMTAtNC40NzctMTAtMTB6IiBmaWxsPSJjdXJyZW50Q29sb3IiLz48cGF0aCBkPSJNMTEuMjUgOC4yNjVhLjc2Ljc2IDAgMDEuNzUtLjc3Ljc2Ljc2IDAgMDEuNzUuNzd2Ni42MDRsLjk3LS45OTRjLjI5My0uMy43NjctLjMgMS4wNiAwIC4yOTMuMy4yOTMuNzg3IDAgMS4wODhsLTIuMjUgMi4zMDdjLS4yOTMuMy0uNzY3LjMtMS4wNiAwbC0yLjI1LTIuMzA3YS43ODMuNzgzIDAgMDEwLTEuMDg4Yy4yOTMtLjMuNzY3LS4zIDEuMDYgMGwuOTcuOTk0VjguMjY1eiIgZmlsbD0iY3VycmVudENvbG9yIi8+PC9zdmc+";